import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { invoiceTypeCounts } from "../Constants/common";
import { _fetchInovoicesCount } from "../services/clientInvoice";
const initialState = {
  isLoading: false,
  typeCount: invoiceTypeCounts,
};

export const fetchClientInvoiceCount = createAsyncThunk(
  "timesheets/fetchClientInvoiceCount",
  async (data, thunkAPI) => {
    const response = _fetchInovoicesCount(data);
    response
      .then((res) => {
        const invoices = res?.data?.invoice_count;
        const obj = { invoices };
        const arr = invoiceTypeCounts.map((ele) => {
          let type = ele.type;
          return {
            ...ele,
            value: obj[type] || 0,
          };
        });
        thunkAPI.dispatch(updateTypeCount(arr));
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        // console.log('finally');
      });
  },
);

const invoicesCountSlice = createSlice({
  name: "invoicesCount",
  initialState,
  reducers: {
    updateTypeCount: (state, action) => {
      state.typeCount = action.payload;
    },
  },
});

export const { updateTypeCount } = invoicesCountSlice.actions;

export default invoicesCountSlice.reducer;
